import PropTypes from 'prop-types';
import React from 'react';

import {ALL_SUPPORTED_FIELD_TYPES} from 'notebook/data-tables/DataTableConfigEditUtil';
import {
  DATA_TABLE_COLUMN_SHAPE,
  StructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import {PRIMARY_LINK_TYPES} from 'results/PrimaryLinks';
import {FIELD_TYPES_BY_TYPE_STRING, FieldType, FullFieldType} from 'schemas/fields/SchemaFieldConstants';
import Label from 'ui-library/bs/Label';
import {ButtonStyle} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Modal, {ModalButton} from 'ui-library/modals/Modal';

interface SetDataTableColumnTypeModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (args: {selectedFieldType: FullFieldType}) => void;
  column: StructuredTableColumn;
  initialFieldType: FullFieldType;
  allowPrimaryLinkTypes: boolean;
}

interface State {
  selectedFieldType: FullFieldType;
}

export default class SetDataTableColumnTypeModal extends React.Component<
  SetDataTableColumnTypeModalProps,
  State
> {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onRequestSubmit: PropTypes.func.isRequired,

    column: DATA_TABLE_COLUMN_SHAPE.isRequired,
    initialFieldType: PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  };

  constructor(props: SetDataTableColumnTypeModalProps) {
    super(props);
    this.state = {selectedFieldType: props.initialFieldType};
  }

  _getButtons(): Array<ModalButton> {
    return [
      {
        key: 'set',
        onClick: this._handleSubmit,
        style: ButtonStyle.PRIMARY,
        submit: true,
        disabled: false,
        text: 'Set',
      },
    ];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleSubmit = () => {
    this.props.onRequestSubmit({selectedFieldType: this.state.selectedFieldType});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleFieldTypeSelect = (selectedFieldType: FullFieldType) => {
    this.setState({selectedFieldType});
  };

  _getFieldTypeOptions(): Array<JSX.Element> {
    const fieldTypes = ALL_SUPPORTED_FIELD_TYPES.filter(
      (fieldType: FieldType) => this.props.allowPrimaryLinkTypes || !PRIMARY_LINK_TYPES.includes(fieldType)
    ).map((fieldType: FieldType) => FIELD_TYPES_BY_TYPE_STRING[fieldType]);
    return fieldTypes.map((fullFieldType: FullFieldType) => (
      <Option value={fullFieldType} onSelect={this._handleFieldTypeSelect} key={fullFieldType.type}>
        {fullFieldType.label}
      </Option>
    ));
  }

  render(): JSX.Element {
    return (
      <Modal title="Set column type" onRequestClose={this.props.onRequestClose} buttons={this._getButtons()}>
        <div>
          <Label>{`${this.props.column.name} type:`}</Label>
          <span className="u-spacing-left">
            <SelectDropdown
              displayName={this.state.selectedFieldType.label}
              menu={
                <Menu
                  height={Menu.HEIGHTS.MEDIUM}
                  width={Menu.WIDTHS.MEDIUM}
                  value={this.state.selectedFieldType}
                >
                  {this._getFieldTypeOptions()}
                </Menu>
              }
            />
          </span>
        </div>
      </Modal>
    );
  }
}
